import { render, staticRenderFns } from "./InformationMenu.vue?vue&type=template&id=820fc5ea&scoped=true"
import script from "./InformationMenu.vue?vue&type=script&lang=ts"
export * from "./InformationMenu.vue?vue&type=script&lang=ts"
import style0 from "./InformationMenu.vue?vue&type=style&index=0&id=820fc5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820fc5ea",
  null
  
)

export default component.exports